import React, { useEffect, useState } from 'react';
import arrow from '../../../assets/image/arrow.svg';
import Table from '../../../component/table/Table';
import FullCircle from '../../../assets/image/full_circle.png';
import HalfCircle from '../../../assets/image/half_circle.png';
import EmptyCircle from '../../../assets/image/empty_circle.png';
import PageLoader from '../../../component/PageLoader';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getDate } from '../../../utils/dateUtils';
import { fetchPurchaseOrders } from '../../../services/purchaseOrder';
import { fetchPurchaseReceive } from '../../../services/purchase_receive';
import { fetchPurchaseBill } from '../../../services/purchase_bill';
import { fetchPaymentMadeList } from '../../../services/payment_made';
import { fetchCreditNoteList } from '../../../services/credit_note';
import { useDispatch } from 'react-redux';
import { setAdvanceFilter } from '../../../store/action/advanceFilter';

const ArrowIcon = ({ isOpen, onClick }) => (
	<button
		onClick={onClick}
		style={{
			background: 'none',
			border: 'none',
			cursor: 'pointer',
			paddingLeft: '20px',
			transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
			transition: 'transform 0.3s ease',
		}}
		aria-label="Toggle section"
	>
		<img
			src={arrow}
			alt="Arrow Icon"
		/>
	</button>
);

const FaqSection = ({ vendor }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [openSection, setOpenSection] = useState(null);
	const [loader, setLoader] = useState(false);
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;

	const [tableParams, setTableParams] = useState({
		page: 1,
		pageSize: 5,
		orderBy: 'created_at',
		sortBy: 'desc',
		filterBy: 'vendor_id',
		filterValue: id,
	});

	const navigateRouter = (path) => {
		navigate(path);
	};

	const toggleSection = (index) => {
		setOpenSection(openSection === index ? null : index);
	};

	const [tableData, setTableData] = useState({
		currentPage: 1,
		totalPages: 0,
		data: [],
	});

	const faqData = [
		{
			title: 'Purchase Orders',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 110,
					maxWidth: 110,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'PO#',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 140,
					maxWidth: 140,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const PO = JSON?.parse(params?.data['PO#']);
						return (
							<p>
								{PO?.po_number}
								{PO?.is_draft === 1 && (
									<span
										style={{
											backgroundColor: '#718096',
											color: 'white',
											borderRadius: '20px',
											padding: '2px 10px',
											paddingBottom: '3px',
											marginLeft: '10px',
											fontSize: '11px',
										}}
									>
										Draft
									</span>
								)}
							</p>
						);
					},
				},
				{
					field: 'VENDOR NAME',
					suppressSizeToFit: true,
					headerClass: 'HeaderBg',
					flex: 1,
					minWidth: 150,
					cellClass: 'left-align',
				},
				{
					field: 'Status',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 220,
					maxWidth: 260,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const status = params?.data?.Status || '';
						let statusCode = '';

						switch (status) {
							case 'Received':
								statusCode = '#6AA247';
								break;
							case 'Pending':
								statusCode = '#FFC008';
								break;
							case 'Pending Approval':
								statusCode = '#3B58FF';
								break;
							case 'Approved':
								statusCode = '#3B58FF';
								break;
							case 'Issued':
								statusCode = '#3B58FF';
								break;
							case 'Closed':
								statusCode = '#989C95';
								break;
							case 'Deleted':
								statusCode = '#D30000';
								break;
							case 'Partially Received':
								statusCode = '#FFA500';
								break;
							case 'In-Transit':
								statusCode = '#11caf0';
								break;
							default:
								statusCode = '#DC3545';
								break;
						}

						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									height: '24px',
									fontSize: '12px',
									borderRadius: '5px',
									fontWeight: status === 'Draft' ? '' : 'bold',
									margin: '8px 0px',
									color: status === 'Draft' ? 'black' : '#ffffff',
									backgroundColor: status === 'Draft' ? '' : statusCode,
								}}
							>
								{status === 'Draft' ? 'N/A' : status}
							</div>
						);
					},
				},
				{
					field: 'Received',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 100,
					maxWidth: 100,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const received = JSON?.parse(params?.data?.Received) || '';
						if (received === undefined) return;
						const { is_received, is_partially_received, status } = received;

						if (
							is_received === 1 &&
							status !== 'Pending Approval' &&
							status !== 'In-Transit' &&
							status !== 'Cancelled' &&
							status !== 'Issued'
						) {
							return (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										height: '100%',
									}}
								>
									<img
										alt="is_receive?"
										src={FullCircle}
									/>
								</div>
							);
						}

						if (
							is_partially_received === 1 &&
							status !== 'Pending Approval' &&
							status !== 'In-Transit' &&
							status !== 'Cancelled' &&
							status !== 'Issued'
						) {
							return (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										height: '100%',
									}}
								>
									<img
										alt="is_receive?"
										src={HalfCircle}
									/>
								</div>
							);
						}
						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									height: '100%',
								}}
							>
								<img
									alt="is_receive?"
									src={EmptyCircle}
								/>
							</div>
						);
					},
				},
				{
					field: 'Billed',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 100,
					maxWidth: 100,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const billed = JSON?.parse(params?.data?.Billed) || '';
						if (billed === undefined) return;
						const { is_billed, is_partially_billed } = billed;

						if (is_billed === 1) {
							return (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										height: '100%',
									}}
								>
									<img
										alt="is_receive?"
										src={FullCircle}
									/>
								</div>
							);
						}

						if (is_partially_billed === 1) {
							return (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										height: '100%',
									}}
								>
									<img
										alt="is_receive?"
										src={HalfCircle}
									/>
								</div>
							);
						}

						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									height: '100%',
								}}
							>
								<img
									alt="is_receive?"
									src={EmptyCircle}
								/>
							</div>
						);
					},
				},
				{
					field: 'Expected By',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 120,
					maxWidth: 120,
					flex: 1,
					cellClass: 'left-align',
				},
			],
		},
		{
			title: 'Purchase Received',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'PR#',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 180,
					maxWidth: 180,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const PR = JSON?.parse(params?.data?.PR);
						return (
							<p>
								{PR?.pr}
								{PR?.status === 0 && (
									<span
										style={{
											backgroundColor: '#718096',
											color: 'white',
											borderRadius: '20px',
											padding: '2px 10px',
											paddingBottom: '3px',
											marginLeft: '10px',
											fontSize: '11px',
										}}
									>
										Draft
									</span>
								)}
							</p>
						);
					},
				},
				{
					field: 'PO#',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'VENDOR NAME',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'RECEIVED',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 120,
					maxWidth: 120,
					flex: 1,
					cellClass: 'center-align',
					cellRenderer: (params) => {
						const status = params?.data?.RECEIVED || 0;
						if (status === 1) {
							return (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										height: '100%',
									}}
								>
									{' '}
									<img src={FullCircle} />
								</div>
							);
						}
						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									height: '100%',
								}}
							>
								<img src={EmptyCircle} />
							</div>
						);
					},
				},
				{
					field: 'BILLED',
					headerClass: 'HeaderBg left-align',
					suppressSizeToFit: true,
					minWidth: 100,
					maxWidth: 100,
					flex: 1,
					cellClass: 'center-align',
					cellRenderer: (params) => {
						const status = params?.data?.BILLED || '';
						if (status === 3) {
							return (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										height: '100%',
									}}
								>
									<img
										src={FullCircle}
										style={{ alignItems: 'center' }}
									/>
								</div>
							);
						}
						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									height: '100%',
								}}
							>
								<img
									src={EmptyCircle}
									style={{ alignItems: 'center' }}
								/>
							</div>
						);
					},
				},
			],
		},
		{
			title: 'Purchase Bills',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'PURCHASE BILL#',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 250,
					maxWidth: 250,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const PB = JSON?.parse(params?.data?.PB);
						return (
							<p style={{ alignItems: 'center' }}>
								{PB?.pb_number}
								{PB?.status === 0 && (
									<span
										style={{
											backgroundColor: '#718096',
											color: 'white',
											borderRadius: '20px',
											padding: '2px 10px',
											paddingBottom: '3px',
											marginLeft: '10px',
											fontSize: '11px',
										}}
									>
										Draft
									</span>
								)}
							</p>
						);
					},
				},

				{
					field: 'VENDOR NAME',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'STATUS',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 200,
					maxWidth: 200,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						const status = params?.data?.status || 0;
						if (status) {
							return (
								<p>
									<span
										style={{
											color:
												status === 0
													? '#000'
													: status === 1
														? '#FFC008'
														: status === 2
															? '#FFA500'
															: '#6AA247',
										}}
									>
										{status === 0
											? 'N/A'
											: status === 1
												? 'Open'
												: status === 2
													? 'Partially Paid'
													: 'Closed'}
									</span>
								</p>
							);
						} else {
							return (
								<p>
									<span
										style={{
											color: '#000',
										}}
									>
										N / A
									</span>
								</p>
							);
						}
					},
				},
				{
					field: 'AMOUNT',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 180,
					maxWidth: 180,
					flex: 1,
					cellClass: 'right-align',
				},
				{
					field: 'BALANCE DUE',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 180,
					maxWidth: 180,
					flex: 1,
					cellClass: 'right-align',
				},
			],
		},
		{
			title: 'Payment Made',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'PAYMENT#',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 200,
					maxWidth: 200,
					flex: 1,
					cellClass: 'left-align',
				},

				{
					field: 'VENDOR NAME',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},

				{
					field: 'MODE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 250,
					maxWidth: 250,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'AMOUNT',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 200,
					maxWidth: 200,
					flex: 1,
					cellClass: 'right-align',
				},
			],
		},
		{
			title: 'Credit Notes',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'CREDIT NOTE#',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 220,
					maxWidth: 220,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const PN = JSON.parse(params.data['CN']);
						return (
							<p>
								{PN?.cn}
								{PN?.is_draft === 0 && (
									<span
										style={{
											backgroundColor: '#718096',
											color: 'white',
											borderRadius: '20px',
											padding: '2px 10px',
											paddingBottom: '3px',
											marginLeft: '10px',
											fontSize: '11px',
										}}
									>
										Draft
									</span>
								)}
							</p>
						);
					},
				},

				{
					field: 'VENDOR NAME',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'STATUS',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
					cellRenderer: (params) => {
						if (!params) return;
						const status = params.data?.status;
						return (
							<p>
								{status}
								{/* {PN?.is_draft === 0 && (
									<span
										style={{
											backgroundColor: '#718096',
											color: 'white',
											borderRadius: '20px',
											padding: '2px 10px',
											paddingBottom: '3px',
											marginLeft: '10px',
											fontSize: '11px',
										}}
									>
										Draft
									</span>
								)} */}
							</p>
						);
					},
				},
				{
					field: 'AMOUNT',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'right-align',
				},
			],
		},
	];

	async function handleFetchTableData(index) {
		if (index === 0) {
			try {
				setLoader(true);
				const { purchaseOrders, totalPages } = await fetchPurchaseOrders(tableParams);
				const mappedPurchaseOrderTableData = purchaseOrders.map((purchase) => {
					return {
						id: purchase.purchase_order_id,
						DATE: getDate(purchase?.date),
						'PO#': JSON.stringify({
							po_number: purchase?.purchase_order_number,
							is_draft: purchase?.is_draft,
						}),
						'VENDOR NAME': purchase?.vendor?.vendor_name,
						Status: purchase?.status || 'N/A',
						Received: JSON.stringify({
							is_received: purchase.is_received,
							is_partially_received: purchase.is_partially_received,
							status: purchase?.status,
						}),
						Billed: JSON.stringify({
							is_billed: purchase?.is_billed,
							is_partially_billed: purchase?.is_partially_billed,
						}),
						'Expected By':
							purchase?.expected_delivery_date === null
								? 'N/A'
								: getDate(purchase?.expected_delivery_date),
					};
				});
				setTableData((prev) => ({
					...prev,
					data: mappedPurchaseOrderTableData,
					totalPages,
				}));
			} catch (error) {
				toast.error('Something went wrong!');
			} finally {
				setLoader(false);
			}
		} else if (index === 1) {
			try {
				setLoader(true);
				const { purchaseReceive, totalPages } = await fetchPurchaseReceive(tableParams);
				const tableData = purchaseReceive.map((pr) => {
					return {
						id: pr.purchase_receive_id,
						DATE: getDate(pr.receive_date),
						PR: JSON.stringify({
							pr: pr?.purchase_receive_number || 'PR-' + pr?.purchase_receive_id,
							status: pr?.status,
						}),
						'PO#': pr.purchase_order.purchase_order_number || pr.purchase_order_number,
						'VENDOR NAME': pr.vendor.vendor_name,
						RECEIVED: pr?.status,
						BILLED: JSON.stringify({
							is_billed: pr?.is_billed,
							is_partially_billed: pr?.is_partially_billed,
						}),
					};
				});
				setTableData((prev) => ({
					...prev,
					data: tableData,
					totalPages,
				}));
			} catch (error) {
				toast.error('Something went wrong!');
			} finally {
				setLoader(false);
			}
		} else if (index === 2) {
			try {
				setLoader(true);
				const { purchaseBills, totalPages } = await fetchPurchaseBill(tableParams);
				const data = purchaseBills
					? purchaseBills.map((pr) => {
							return {
								id: pr.purchase_bill_id,
								DATE: getDate(pr.bill_date),
								PB: JSON.stringify({
									pb_number: pr?.bill_number,
									status: pr?.status,
								}),
								'VENDOR NAME': pr.vendor.vendor_name,
								status: pr?.status,
								AMOUNT: pr?.bill_amount,
								'BALANCE DUE': pr?.due_amount,
							};
						})
					: [];
				setTableData((prev) => ({
					...prev,
					data: data,
					totalPages,
				}));
			} catch (error) {
				toast.error('Something went wrong!');
			} finally {
				setLoader(false);
			}
		} else if (index === 3) {
			try {
				setLoader(true);
				const res = await fetchPaymentMadeList(tableParams);
				const mappedTableData = res?.data
					? res?.data?.map((pm) => {
							return {
								id: pm?.payment_made_id,
								'PAYMENT#': pm?.payment_number,
								DATE: getDate(pm?.date),
								'VENDOR NAME': pm?.vendor?.vendor_name,
								MODE: pm?.payment_mode,
								AMOUNT: pm?.payment_amount,
							};
						})
					: [];

				setTableData((prev) => ({
					...prev,
					data: mappedTableData,
					totalPages: res?.totalPages,
				}));
			} catch (error) {
				toast.error('Somethings went wrong!');
			} finally {
				setLoader(false);
			}
		} else if (index === 4) {
			try {
				setLoader(true);
				const { data, totalPages } = await fetchCreditNoteList(tableParams);
				const creditNoteData = data?.map((ele) => {
					return {
						id: ele.credit_note_id,
						DATE: getDate(ele?.date),
						CN: JSON.stringify({ cn: ele?.credit_note_number, is_draft: ele?.status }),
						'VENDOR NAME': ele?.vendor?.vendor_name,
						status: ele?.status === 0 ? 'N/A' : ele?.status === 1 ? 'Active' : 'Closed',
						AMOUNT: Number(ele?.credit_note_amount) || 0,
					};
				});
				setTableData((prev) => ({
					...prev,
					data: creditNoteData,
					totalPages,
				}));
			} catch (error) {
				toast.error('somethings went wrong!');
			} finally {
				setLoader(false);
			}
		}
	}

	function handleCreateButton(index) {
		let baseUrl = `/user/${suburl}/`;
		const urlMap = {
			0: baseUrl + `purchases-order-create`,
			1: baseUrl + `purchases-receive-create`,
			2: baseUrl + `purchases-bills-create`,
			3: baseUrl + `payment-made-create`,
			4: baseUrl + `credit-note-create`,
		};

		navigate(urlMap[Number(index)], { state: vendor });
	}

	function handleListButton(index) {
		let baseUrl = `/user/${suburl}/`;
		const urlMap = {
			0: baseUrl + `purchases-order`,
			1: baseUrl + `purchases-receive`,
			2: baseUrl + `purchases-bills`,
			3: baseUrl + `payment-made`,
			4: baseUrl + `credit-note`,
		};

		const params = {
			page: 1,
			totalPages: 0,
			pageSize: 20,
			filters: {
				vendor_name: vendor.value,
			},
			isAdvanceFilterApplied: true,
			selectedInputs: [
				{
					key: 'vendor_name',
					label: 'Vendor Name',
					data: [
						{
							key: vendor?.value,
							value: vendor?.value,
						},
					],
					value: vendor?.value,
				},
			],
		};
		dispatch(setAdvanceFilter(params));
		navigate(urlMap[Number(index)], { state: vendor });
	}

	return (
		<div>
			{faqData.map((section, index) => (
				<div
					key={index}
					style={{ marginBottom: '8px' }}
				>
					{/* Section Header */}
					<div
						style={{
							cursor: 'pointer',
							background: '#F6F6F9',
							display: 'flex',
							height: '58px',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}
						onClick={() => {
							toggleSection(index);
							handleFetchTableData(index);
							setTableData({
								currentPage: 1,
								totalPages: 0,
								data: [],
							});
						}}
					>
						{/* Left Arrow Icon */}
						<div
							onClick={() => {
								toggleSection(index);
								handleFetchTableData(index);
								setTableData({
									currentPage: 1,
									totalPages: 0,
									data: [],
								});
							}}
							style={{ display: 'flex', alignItems: 'center' }}
						>
							<ArrowIcon isOpen={openSection === index} />
							<span style={{ marginLeft: '0px' }}>{section.title}</span>
						</div>

						{/* Right "New +" Button */}
						<button
							onClick={() => {
								handleCreateButton(index);
							}}
							style={{
								backgroundColor: '#3B58FF',
								fontSize: '16',
								fontWeight: '600',
								marginRight: '8px',
								width: '84px',
								height: '42px',
								color: 'white',
								border: 'none',
								borderRadius: '6px',
								cursor: 'pointer',
							}}
						>
							New +
						</button>
					</div>

					{/* Section Content */}
					{openSection === index && (
						<div style={{ borderBottom: '1px solid #ccc', backgroundColor: '#F6F6F9' }}>
							{loader ? (
								<PageLoader />
							) : (
								<>
									{/* Table Content */}
									<div style={styles.tableContainer}>
										<Table
											coloum={section.columns}
											row={tableData?.data}
											onRowClick={(rowId) => {
												if (index === 0) {
													navigateRouter(`/user/${suburl}/purchases-order-details/${rowId}`);
												} else if (index === 1) {
													navigateRouter(`/user/${suburl}/purchases-receive-details/${rowId}`);
												} else if (index === 2) {
													navigateRouter(`/user/${suburl}/purchases-bills-details/${rowId}`);
												} else if (index === 3) {
													navigateRouter(`/user/${suburl}/payment-made-details/${rowId}`);
												} else {
													navigateRouter(`/user/${suburl}/credit-note-details/${rowId}`);
												}
											}}
										/>
									</div>
									<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
										<button
											style={{
												fontSize: '16',
												fontWeight: '600',
												marginRight: '8px',
												width: '84px',
												height: '42px',
												color: 'black',
												border: '1px solid #3B58FF',
												background: 'transparent',
												padding: '4px 8px',
												marginBottom: '7px',
												borderRadius: '6px',
												cursor: 'pointer',
											}}
											onClick={() => handleListButton(index)}
										>
											View All
										</button>
									</div>
								</>
							)}
						</div>
					)}
				</div>
			))}
		</div>
	);
};

const styles = {
	tableContainer: {
		width: '100%',
		maxHeight: '300px',
		overflowY: 'hidden',
	},
};

export default FaqSection;
